module.exports = __webpack_public_path__ + "img/carnet.75d6aae1.png";